module.exports = __webpack_public_path__ + "img/thu.0b39ea01.png";